import { render, staticRenderFns } from "./UyapHacizTalepForm.vue?vue&type=template&id=33d87c01"
import script from "./UyapHacizTalepForm.vue?vue&type=script&lang=ts"
export * from "./UyapHacizTalepForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports